import { AulaEditor } from '@ublend-npm/aula-editor';
import withFileBlocksValidation from './withFileBlocksValidation';
import withAnalytics from './withAnalytics';
import withCustomStyles from './withCustomStyles';
import withErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import withFileScanFromRedux from './withFileScanFromRedux';

const AulaEditorWithAnalyticsWithoutPlugins = withErrorBoundary(
  withCustomStyles(
    withFileScanFromRedux(withAnalytics(withFileBlocksValidation(AulaEditor)))
  ),
  { ignore: true }
);

export default AulaEditorWithAnalyticsWithoutPlugins;
